<!-- @Version 1.1.0 -->
<a del="noopener noreferer" [attr.href]="TRANSLATE_PATH.HEADER_ACTION_LOGO_LINK | translateDesign" cdkMonitorSubtreeFocus>
   <span>
      <img [attr.data-height]="TRANSLATE_PATH.HEADER_ACTION_LOGO_HEIGHT | translateDesign" class="logo-desktop" [attr.src]="TRANSLATE_PATH.HEADER_ACTION_LOGO_SRC | translateDesign" [attr.alt]="TRANSLATE_PATH.HEADER_ACTION_LOGO_ALT  | translateDesign" data-testid="action_logo">
   </span>
</a>